import { QueryWebEndpoint } from '@nucleus/web-hosting';
import { useUser } from '@nucleus/web-theme';
import { InfiniteData, useSuspenseInfiniteQuery, UseSuspenseInfiniteQueryResult } from '@tanstack/react-query';
import { querySearch } from '../queries/search';

type QueryResult = Awaited<ReturnType<typeof querySearch>>;

export const useSermonSearch = (
  engineId?: string,
  params?: QueryWebEndpoint['queryStringParameters']
): UseSuspenseInfiniteQueryResult<InfiniteData<QueryResult>> => {
  const { currentUser, jwtToken } = useUser();

  return useSuspenseInfiniteQuery({
    queryKey: ['sermonHub', 'sermon', currentUser?.id, params],
    queryFn: ({ pageParam }) => querySearch(engineId, jwtToken, { ...params, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.cursor,
  });
};
